import React from 'react';

import LanguageTexts from '../common/language';

const AppLoader: React.FC = (): JSX.Element => {
  return <p style={{ textAlign: 'center' }}>{LanguageTexts.app.loading}</p>;
};

export default AppLoader;
